import { BrowserRouter } from "react-router-dom"
import { Container } from "./styles"
import ScrollAnimation from "react-animate-on-scroll"
import heroAI from "../../assets/heroai.jpg"
import { useState, useEffect } from "react"

export function Hero() {
  const [displayText, setDisplayText] = useState('');
  const [terminalLines, setTerminalLines] = useState<string[]>([]);
  const fullText = 'Open to Code';

  const terminalCommands = [
    '$ python main.py',
    '> Loading AI model...',
    '> Model loaded ✓',
    '$ git push origin main',
    '> Pushing to remote...',
    '> Successfully pushed ✓',
    '$ npm run build',
    '> Building project...',
    '> Build complete ✓',
    '$ docker compose up',
    '> Starting containers...',
    '> All services running ✓',
  ];

  useEffect(() => {
    let lineIndex = 0;
    let charIndex = 0;
    let currentLine = '';

    const typeTerminal = setInterval(() => {
      if (lineIndex < terminalCommands.length) {
        const command = terminalCommands[lineIndex];
        if (charIndex <= command.length) {
          currentLine = command.slice(0, charIndex);
          setTerminalLines(prev => {
            const newLines = [...prev];
            if (newLines.length > lineIndex) {
              newLines[lineIndex] = currentLine;
            } else {
              newLines.push(currentLine);
            }
            // Keep only last 4 lines
            return newLines.slice(-4);
          });
          charIndex++;
        } else {
          lineIndex++;
          charIndex = 0;
        }
      } else {
        // Reset after all commands
        setTimeout(() => {
          lineIndex = 0;
          charIndex = 0;
          setTerminalLines([]);
        }, 2000);
      }
    }, 80);

    return () => clearInterval(typeTerminal);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let index = 0;
    const typewriter = setInterval(() => {
      if (index <= fullText.length) {
        setDisplayText(fullText.slice(0, index));
        index++;
      } else {
        // Reset and start again after a pause
        setTimeout(() => {
          index = 0;
        }, 2000);
      }
    }, 150);

    return () => clearInterval(typewriter);
  }, []);

  return (
    <Container id="home">
      <div className="hero-text">
        <ScrollAnimation animateIn="fadeInUp">
          <p className="greeting">Hello, I'm <span className="name-highlight">Kirti Kamal</span> <span className="wave-emoji">👋</span></p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInUp" delay={0.2 * 1000}>
          <h1>GenAI Engineer</h1>
          <p className="company-tag">at Capgemini</p>
        </ScrollAnimation>
        
        <ScrollAnimation animateIn="fadeInUp" delay={0.6 * 1000}>
          <p className="intro-text">
            I specialize in designing <span className="gradient-text">Agentic AI architectures</span> that 
            streamline complex real-world processes using multi-agent collaboration, 
            LLM-driven automation, and intelligent workflow orchestration.
          </p>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInUp" delay={0.8 * 1000}>
          <p className="intro-text highlight">
            As a former <span className="gradient-text">Gold Microsoft Student Ambassador</span>, 
            I've led technical workshops, mentored developers, and built vibrant tech communities — 
            empowering others through knowledge sharing and open innovation.
          </p>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInUp" delay={1 * 1000}>
          <p className="intro-text">
            My passion lies in building AI systems that <em>think</em>, <em>collaborate</em>, 
            and solve real business challenges — while staying human-centered and accessible.
          </p>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInUp" delay={1.2 * 1000}>
          <BrowserRouter>
            <a href="#contact" className="button">Get in Touch</a>
          </BrowserRouter>
        </ScrollAnimation>
      </div>

      <div className="hero-image">
        <ScrollAnimation animateIn="fadeInRight" delay={1 * 1000}>
          <div className="ai-card">
            <div className="ai-card-glow"></div>
            <img src={heroAI} alt="AI Illustration" className="ai-image" />
            <div className="ai-card-content">
              <div className="terminal-container">
                <div className="terminal-header">
                  <span className="terminal-dot red"></span>
                  <span className="terminal-dot yellow"></span>
                  <span className="terminal-dot green"></span>
                  <span className="terminal-title">kirti@dev ~ </span>
                </div>
                <div className="terminal-body">
                  {terminalLines.map((line, index) => (
                    <div key={index} className={`terminal-line ${line.startsWith('$') ? 'command' : 'output'}`}>
                      {line}
                    </div>
                  ))}
                  <span className="terminal-cursor">▊</span>
                </div>
              </div>
              <div className="status-indicator">
                <span className="pulse-dot"></span>
                <span className="typing-text">{displayText}</span>
                <span className="cursor">|</span>
              </div>
            </div>
          </div>
        </ScrollAnimation>
      </div>
    </Container>
  )
}